<template>
  <transition name="st-fade">
    <div class="st-overlay" v-if="visible">
      <div class="st-dialog" role="dialog" aria-modal="true" aria-label="严正声明">
        <div class="st-scroll" ref="scroll" @scroll="onScroll">
          <statement-content></statement-content>
        </div>
        <div class="st-footer">
          <button
            class="st-btn st-btn-primary"
            :class="{ 'st-btn-disabled': !scrolledToEnd }"
            :disabled="!scrolledToEnd"
            @click="close">{{ scrolledToEnd ? '我已知晓，进入官网' : '请阅读至文末' }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import StatementContent from './StatementContent'

export default {
  name: 'StatementDialog',
  components: {
    StatementContent
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scrolledToEnd: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (typeof document !== 'undefined') {
          document.body.style.overflow = val ? 'hidden' : ''
        }
        if (val) {
          this.scrolledToEnd = false
          var self = this
          this.$nextTick(function () {
            self.checkScroll()
          })
        }
      }
    }
  },
  beforeDestroy: function () {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
  },
  methods: {
    onScroll: function () {
      var el = this.$refs.scroll
      if (!el) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        this.scrolledToEnd = true
      }
    },
    // 内容不足一屏（无滚动条）时直接可点击
    checkScroll: function () {
      var el = this.$refs.scroll
      if (!el) return
      if (el.scrollHeight - el.clientHeight <= 5) {
        this.scrolledToEnd = true
      }
    },
    close: function () {
      this.$emit('close')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.st-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.62);
  z-index: 3200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.st-dialog {
  width: 780px;
  max-width: 100%;
  max-height: calc(100vh - 40px);
  background: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
}
.st-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 34px 34px 30px;
}
.st-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px 20px;
  background: #fafafa;
  border-top: 1px solid #eeeeee;
}
.st-btn {
  cursor: pointer;
  font-size: 15px;
  line-height: 20px;
  padding: 10px 26px;
  border-radius: 3px;
  transition: all 0.2s;
}
.st-btn-primary {
  min-width: 220px;
  background: #18386e;
  color: #ffffff;
  border: 1px solid #18386e;
}
.st-btn-primary:hover {
  background: #2a4f92;
  border-color: #2a4f92;
}
.st-btn-disabled,
.st-btn-disabled:hover {
  cursor: not-allowed;
  background: #c0c4cc;
  border-color: #c0c4cc;
  color: #ffffff;
}
.st-fade-enter-active,
.st-fade-leave-active {
  transition: opacity 0.3s;
}
.st-fade-enter,
.st-fade-leave-to {
  opacity: 0;
}
@media (max-width: 640px) {
  .st-overlay {
    padding: 10px;
  }
  .st-dialog {
    max-height: calc(100vh - 20px);
  }
  .st-scroll {
    padding: 22px 16px 24px;
  }
  .st-footer {
    padding: 12px 16px 16px;
  }
  .st-btn-primary {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatementDialog.vue